import React, { useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { t } from 'i18next';
import doneSvg from '@/assets/check.svg';
import styles from './product-area-sorter-popup.module.scss';
import { useProductArea } from '../product-area/context';
import BackdropArea from '../menu/BackdropArea';
import { SortValue } from '../product-area/store/area-filters';
import { Icon } from "@/elements-react/fix-icon";
import { useLayoutType } from "@/util-react/layout.tsx";
import { Popup } from "@/uikit";

export const ProductAreaSorterPopup = () => {
  const store = useProductArea();
  const options = store.options.sorters.map((item) => ({
    id: item.key,
    name: item.name,
    selected: store.filters.sort === item.key,
  }));
  const { layoutType, layoutStyleType, defaultLayoutStyleType } = useLayoutType();

  const onSelect = useCallback((id: string) => {
    store.changeSort('sorter', id as SortValue);
    store.applySorterPopup();
  }, [store]);

  const handleClose = useCallback(() => {
    store.closeSorterPopup();
  }, [store]);

  const anchor = useMemo(() => {
    return document.querySelector('.sorters') as Element;
  }, []);

  return (
    <div className={classNames(styles.sorterPopup, styles[defaultLayoutStyleType])}>
      <BackdropArea onClick={handleClose} />
      <Popup
        anchor={anchor}
        placement="bottom-start"
        distance={10}
        arrow
        active={true}
        className={styles.popup}
        onClose={handleClose}
      >
        <div className={styles.box}>
          <div className={styles.header}>
            <div className={styles.title}>{t('ts3qxbgz137nkufi.sort-by', 'Sort by')}</div>
          </div>
          <div className={styles.content}>
            <div className={styles.inner}>
              <div className={styles.options}>
                {options.map((item) => (
                  <div
                    key={item.id}
                    className={classNames(styles.option, { [styles.selected]: item.selected })}
                    onClick={() => onSelect(item.id)}
                  >
                    <div className={styles.name}>{item.name}</div>
                    {item.selected && <Icon className={styles.icon} src={doneSvg} width={20} height={20} />}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ProductAreaSorterPopup;
